import create from './create'
import list from './list'
import del from './delete'

export default {
  namespaced: true,
  modules: {
    create,
    list,
    del
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/index.js